
import Base16 from './Base16.js'
import Base32 from './Base32.js'
import Base64 from './Base64.js'

export default class Baser {
  static base16 = new Base16()
  static base32 = new Base32()
  static base32crockford = new Base32('base32crockford')
  static base32hex = new Base32('base32hex')
  static base64 = new Base64()
  static base64url = new Base64('base64url')

  static Base16 = Base16
  static Base32 = Base32
  static Base64 = Base64
}
